import {
  Component,
  Input,
  OnInit,
  ViewChild,
  HostListener,
  Output,
  EventEmitter,
  ElementRef,
} from '@angular/core';
import { ResultpageService } from '../../../share/service/resultpage.service';
import {
  FilterOptions,
  OffersOfApplication,
  Loan,
  SortOptions,
} from '../../../share/type/result_type';
import { CurrencyPipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { apptrackAddSecondDeptorUrl } from '../../../utils/url';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss'],
})
export class OfferComponent implements OnInit {
  @Input() filterDataOptions!: FilterOptions;
  @Input() noOffersData: OffersOfApplication[] = [];
  @Input() offersData: OffersOfApplication[] = [];
  @Input() loanFilterData!: Loan;
  @Input() showDefaultPlaceholders!: boolean;
  @Input() time!: number;
  @Input() eternalPage!: boolean;
  @Input() resultPage!: boolean;
  @Input() twoApplicants!: boolean;
  @Input() apptrackToken!: string;
  @Input() pageType?: string;

  @Output() filterOutput = new EventEmitter<string>();

  @ViewChild('sorting') sorting: ElementRef;

  //---close sorting dropdown if click outside of sorting---
  @HostListener('document:click', ['$event']) clickout(event: any) {
    if (!this?.sorting?.nativeElement?.contains(event?.target)) {
      const filterButton = document.querySelector(
        '.filter__dropbtn',
      ) as HTMLElement;
      filterButton?.classList?.remove('openDropdown');
    }
  }
  //---close sorting dropdown if click outside of sorting---

  public sortingDropdown!: SortOptions[] | undefined;
  public sortingValue!: SortOptions;
  public explanation: boolean = true;
  public filterData: any = {};
  public chipsData: any[] = [];
  public minRate!: number;
  public minAmount!: number;
  public maxAmount!: number;
  public minMonth!: number;
  public maxMonth!: number;
  public loanAmount!: number;
  public filterState: any = 1;

  public search: boolean = true;
  public anyOffers: boolean = false;
  public filterOverlay!: boolean;
  public loanFilterDataValue: number;
  public loanFilterDataDuration: number;
  public showSalesBox: boolean = true;

  private offerDataSubscription: Subscription;
  private filterOptionsSubscription: Subscription;
  private filterSubscription: Subscription;
  private loanSubscription: Subscription;
  private filterStateSubscription: Subscription;
  private overlaySubscription: Subscription;
  private resultPageSubscription: Subscription;

  constructor(
    public resultpageService: ResultpageService,
    private currencyPipe: CurrencyPipe,
  ) {}

  ngOnInit(): void {
    this.getOffersData();
    this.getFilterData();
    this.getLoanData();
    this.getFilterOptions();
    this.getDataValues();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let crmTokenParam = urlParams.get('crmt') ?? undefined;

    if (crmTokenParam) {
      this.showSalesBox = false;
    }

    this.overlaySubscription = this.resultpageService.overlayObserv$.subscribe(
      (overlay) => {
        this.filterOverlay = overlay;
      },
    );
  }

  /**
   * Update data on submit
   */
  getDataValues() {
    this.resultPageSubscription =
      this.resultpageService.loanDataPostObserv$.subscribe((data) => {
        if (data !== 1) {
          this.loanFilterDataValue = data?.value;
          this.loanFilterDataDuration = data?.duration;
        }
      });
  }

  ngOnDestroy() {
    this.offerDataSubscription.unsubscribe();
    this.filterOptionsSubscription.unsubscribe();
    this.filterSubscription.unsubscribe();
    this.loanSubscription.unsubscribe();
    this.resultPageSubscription.unsubscribe();

    if (this.filterState !== 1) {
      this.filterStateSubscription.unsubscribe();
    }
    this.overlaySubscription.unsubscribe();
  }

  redirectToApptrack() {
    window.location.href = apptrackAddSecondDeptorUrl(this.apptrackToken);
  }

  getOffersData() {
    this.offerDataSubscription =
      this.resultpageService.offersDataObserv$.subscribe((data) => {
        if (data !== 1) {
          this.createChipsFilter();
        }
      });
  }
  getFilterOptions(): void {
    this.filterOptionsSubscription =
      this.resultpageService.filerOptionsDataObserv$.subscribe((data) => {
        if (data !== 1) {
          this.filterDataOptions = data;
          this.minAmount =
            data.loanAmount && data.loanAmount.length !== 0
              ? data.loanAmount[0].value
              : 0;
          this.maxAmount =
            data.loanAmount && data.loanAmount.length !== 0
              ? data.loanAmount[data.loanAmount.length - 1].value
              : 0;
          this.minMonth =
            data.creditDuration && data.creditDuration.length !== 0
              ? data.creditDuration[0].value
              : 0;
          this.maxMonth =
            data.creditDuration && data.creditDuration.length !== 0
              ? data.creditDuration[data.creditDuration.length - 1].value
              : 0;

          this.sortingDropdown = data?.sorting?.filter((sortItem) => {
            return (
              sortItem.value == 'RELEVANCE' ||
              sortItem.value == 'LOWEST_INTEREST'
            );
          });
        } else {
          this.sortingValue = {
            name: '"Relevanz"',
            value: 'RELEVANCE',
          };
        }
      });
  }
  getLoanData(): void {
    this.loanSubscription =
      this.resultpageService.loanStateDataObserv$.subscribe((data) => {
        if (data !== 1) {
          this.loanFilterData = data;
          this.loanFilterDataValue = data?.value;
          this.loanFilterDataDuration = data?.duration;
        }
      });
  }
  getFilterData(): void {
    this.filterSubscription =
      this.resultpageService.filterDataPostObserv$.subscribe((data) => {
        if (data !== 1) {
          this.filterData = data;
          // Keep sortingValue in sync with filterDataPost so the active sort tab
          if (data.sorting?.[0]) {
            this.sortingValue = data.sorting[0];
          }
        }
      });
  }

  closeSorting(): void {
    const sorting = document.getElementById('sorting') as HTMLElement;
    sorting.classList.remove('openSorting');
  }

  openSorting(): void {
    const filterButton = document.querySelector(
      '.filter__dropbtn',
    ) as HTMLElement;
    filterButton.classList.toggle('openDropdown');
  }

  onChangeSortingTabs(item: SortOptions): void {
    this.updateSorting(item);
  }

  onTabKeydown(event: KeyboardEvent, item: SortOptions, index: number): void {
    const key = event.key;

    // Handle Enter and Space key activation
    if (key === 'Enter' || key === ' ') {
      event.preventDefault();
      this.onChangeSortingTabs(item);
      return;
    }

    // Handle arrow key navigation
    if (key === 'ArrowLeft' || key === 'ArrowRight') {
      event.preventDefault();
      const tabs = Array.from(
        document.querySelectorAll('.offer_tab-sort--item'),
      ) as HTMLElement[];
      let nextIndex: number;

      if (key === 'ArrowLeft') {
        nextIndex = index === 0 ? tabs.length - 1 : index - 1;
      } else {
        nextIndex = index === tabs.length - 1 ? 0 : index + 1;
      }

      // Focus the next tab
      tabs[nextIndex]?.focus();
    }
  }

  onChangeSorting(item: SortOptions): void {
    const filterButton = document.querySelector(
      '.filter__dropbtn',
    ) as HTMLElement;
    filterButton.classList.remove('openDropdown');
    const sorting = document.getElementById('sorting') as HTMLElement;
    sorting.classList.remove('openSorting');
    this.updateSorting(item);
  }

  private updateSorting(item: SortOptions): void {
    //---show overlay on filter and chips until data load---
    this.filterOverlay = true;
    this.resultpageService.updatedOverlay(this.filterOverlay);
    //---show overlay on filter and chips until data load---
    this.sortingValue = item;

    this.filterData.sorting = [item];

    //---update local sorting option---
    this.resultpageService.updatedDataSorting(item);
    //---update local sorting option---

    //---update sorting option for mobile layout---
    this.resultpageService.updatedFilerDataPost(this.filterData);
    //---update sorting option for mobile layout---

    //---create pos request in parent component---
    this.filterOutput.emit();
    //---create pos request in parent component---
  }

  closeExplanation(): void {
    this.explanation = false;
  }

  //---create hints for filters' titles---
  createChipsFilter(): void {
    this.chipsData = [];
    for (let key in this.filterData) {
      if (this.filterData.hasOwnProperty(key)) {
        switch (key) {
          case 'monthlyRate':
            if (
              this.filterData[key] &&
              this.filterData[key].length !== 0 &&
              this.filterData[key][0].value !== 0 &&
              this.filterData[key][0].value !==
                this.filterDataOptions[key][
                  this.filterDataOptions[key].length - 1
                ].value
            ) {
              let obj: any = {};
              obj['text'] =
                'mtl. Rate bis ' +
                this.currencyPipe.transform(
                  this.filterData[key][0].value,
                  'EUR',
                  '',
                  '1.0-2',
                ) +
                ' €';
              obj['value'] = this.filterData[key][0].value;
              obj['key'] = key;
              if (this.chipsData.length !== 0) {
                let checkElement = this.chipsData.find(
                  (el) => el.key == obj.key,
                );
                if (checkElement) {
                  checkElement = obj;
                } else {
                  this.chipsData.push(obj);
                }
              } else {
                this.chipsData.push(obj);
              }
            }
            break;
          case 'loanAmount':
            this.filterData[key].map((num: { value: number }) => {
              let obj: any = {};
              obj['text'] =
                this.currencyPipe.transform(num.value, 'EUR', '', '1.0-2') +
                ' €';
              obj['value'] = num.value;
              obj['key'] = key;
              this.chipsData.push(obj);
            });
            break;
          case 'creditDuration':
            this.filterData[key].map((num: { value: number }) => {
              let obj: any = {};
              obj['text'] = num.value + ' Monate';
              obj['value'] = num.value;
              obj['key'] = key;
              this.chipsData.push(obj);
            });
            break;
          case 'creditProtection':
            this.filterData[key].map((str: { value: string }) => {
              let objText = this.filterDataOptions.creditProtection
                ? this.filterDataOptions.creditProtection.find(
                    (obj: any) => obj.value == str.value,
                  )
                : '';
              let obj: any = {};
              obj['text'] = objText['name'];
              obj['value'] = str;
              obj['key'] = key;
              this.chipsData.push(obj);
            });
            break;
          case 'flexibleRepayment':
            for (const property in this.filterData[key]) {
              this.filterData[key][property].map((str: { value: string }) => {
                let objText =
                  this.filterDataOptions.flexibleRepayment &&
                  this.filterDataOptions.flexibleRepayment[property]
                    ? this.filterDataOptions.flexibleRepayment[property].find(
                        (obj: any) => obj.value == str.value,
                      )
                    : '';
                let obj: any = {};
                obj['text'] = objText.name;
                obj['value'] = str;
                obj['key'] = key;
                obj['type'] = objText.type;
                this.chipsData.push(obj);
              });
            }
            break;
          case 'onlineContract':
            if (this.filterData[key][0] == 'YES') {
              let objOnline: any = {};
              objOnline['text'] = 'Online Abschluss';
              objOnline['value'] = this.filterData[key];
              objOnline['key'] = key;
              objOnline['viewStyle'] = 'radio';
              this.chipsData.push(objOnline);
            }
            break;
          case 'docsRequired':
            if (this.filterData[key][0] == 'YES') {
              let objOnline: any = {};
              objOnline['text'] = 'keine Nachweise';
              objOnline['value'] = this.filterData[key];
              objOnline['key'] = key;
              objOnline['viewStyle'] = 'radio';
              this.chipsData.push(objOnline);
            }
            break;
          case 'payout':
            if (this.filterData[key][0] == 'YES') {
              let objOnline: any = {};
              objOnline['text'] = 'Auszahlung';
              objOnline['value'] = this.filterData[key];
              objOnline['key'] = key;
              objOnline['viewStyle'] = 'radio';
              this.chipsData.push(objOnline);
            }
            break;
        }
      }
    }
  }
  //---create hints for filters' titles---

  removeChip(el): void {
    //---show overlay on filter and chips until data load---
    this.filterOverlay = true;
    this.resultpageService.updatedOverlay(this.filterOverlay);
    //---show overlay on filter and chips until data load---

    this.filterStateSubscription =
      this.resultpageService.filterStateDataObserv$.subscribe((data) => {
        if (data !== 1) {
          this.filterState = data;
        }
      });
    if (el.key == 'creditProtection') {
      this.filterData[el.key] = this.filterData[el.key].filter(
        (obj) => obj.value != el.value.value,
      );
      this.filterState = this.filterState.filter(
        (obj) => !(obj.key == el.key && obj.value == el.value.value),
      );
    } else if (el.key == 'flexibleRepayment') {
      this.filterData[el.key][el.type] = this.filterData[el.key][
        el.type
      ].filter((obj) => obj.value != el.value.value);
      this.filterState = this.filterState.filter(
        (obj) => !(obj.key == el.key && obj.value == el.value.value),
      );
    } else if (el.viewStyle == 'radio') {
      this.filterData[el.key] = ['ALL'];
      this.filterState = this.filterState.filter((obj) => obj.key != el.key);
    } else {
      this.filterData[el.key] = this.filterData[el.key].filter(
        (obj) => obj.value != el.value,
      );
      this.filterState = this.filterState.filter(
        (obj) => !(obj.key == el.key && obj.value == el.value),
      );
    }

    this.resultpageService.updatedStateFilerData(this.filterState);

    this.resultpageService.updatedFilerDataPost(this.filterData);
    //---create pos request in parent component---
    this.filterOutput.emit();
    //---create pos request in parent component---
  }

  resetFilter(): void {
    //---show overlay on filter and chips until data load---
    this.filterOverlay = true;
    this.resultpageService.updatedOverlay(this.filterOverlay);
    //---show overlay on filter and chips until data load---

    this.resultpageService.updatedStateFilerData([]);
    this.resultpageService.updatedFilerDataPost({});
    //---create pos request in parent component---
    this.filterOutput.emit();
    //---create pos request in parent component---
  }

  trackByOfferId(index: number, offer: OffersOfApplication): string {
    return offer.id;
  }

  trackByChip(index: number, chip: any): string {
    return `${chip?.key ?? ''}-${chip?.value ?? ''}-${index}`;
  }

  trackBySortValue(index: number, item: SortOptions): string {
    return item.value;
  }
}
